import { ActionBar, ChakraBox, FAIconName } from '@equip.health/ui';

const ModalityHasChangedBanner = ({ onClick }: { onClick: () => void }) => {
  return (
    <ChakraBox marginY="6px">
      <ActionBar
        barIcon={FAIconName.exclamationTriangleRegular}
        buttonIcon={FAIconName.scribbleRegular}
        buttonText="Create new"
        id="modality-has-changed-banner"
        onButtonClick={onClick}
        text="The modality has changed since this care plan was created. Please create a new care plan."
        variant="critical"
      />
    </ChakraBox>
  );
};

export default ModalityHasChangedBanner;
